import { FirestoreCollections } from '@griply/types';
import { doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { LifeArea, LocalizedLifeArea } from 'shared/types/life-area';
import { Timestamp } from 'shared/types/timestamp';

import { dateToFirestoreTimestamp } from './converters/date-to-firestore-timestamp';
import {
  BatchDocuments,
  getAuthentication,
  getCollection,
  getDatabase,
} from './helpers';

export const updateLifeAreas = async (
  lifeAreas: Partial<LifeArea | LocalizedLifeArea>[],
) => {
  // Get the currently authenticated user
  const user = (await getAuthentication()).currentUser;

  if (!user) {
    throw Error('unauthenticated');
  }

  const lifeAreaCollection = getCollection(FirestoreCollections.LifeAreas);

  if (lifeAreas.length === 1) {
    // if only one life area is being updated, we can use updateDoc directly
    updateDoc(doc(lifeAreaCollection, lifeAreas[0].id), {
      ...dateToFirestoreTimestamp(lifeAreas[0]),
      updatedAt: serverTimestamp() as unknown as Timestamp,
    });
    return;
  }

  const batchDocuments = new BatchDocuments(getDatabase());

  lifeAreas.forEach((lifeArea) => {
    batchDocuments.updateDocument({
      ref: doc(lifeAreaCollection, lifeArea.id),
      data: {
        ...dateToFirestoreTimestamp(lifeArea),
        updatedAt: serverTimestamp() as unknown as Timestamp,
      },
    });
  });

  batchDocuments.commit();
};
